import { render } from "./Play3dIcon.vue?vue&type=template&id=54ce7f6e"
import script from "./Play3dIcon.vue?vue&type=script&lang=js"
export * from "./Play3dIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__